// gradient.ts
export const gradientColors: string[][] = [
  ['#FF885E', '#FF516A'],
  ['#665FFF', '#5B9DF2'],
  ['#54CB68', '#A0DE7E'],
  ['#FFA85C', '#FFCD6A'],
  ['#665FFF', '#5B9DF2'],
  ['#FF885E', '#FF516A'],
  ['#54CB68', '#A0DE7E']
];

function hashCode(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function getAvatarColors(peerId?: string, backgroundColor?: string): string[] {
  if (backgroundColor) {
    return [backgroundColor, backgroundColor];
  }
  const colorIndex = peerId != null ? hashCode(peerId) % gradientColors.length : 0;
  return gradientColors[colorIndex];
}

export function getInitials(name?: Nullable<string>): string {
  if (!name || name.trim().length === 0) return '';
  const words = name
    .trim()
    .split(' ')
    .filter((s) => s.length > 0);
  if (words.length === 0) return '';
  if (words.length === 1) {
    return words[0].substring(0, 1);
  }
  return words[0].substring(0, 1) + words[words.length - 1].substring(0, 1);
}
